import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../environments/environment';
import {District, IDistrict} from '../models/district.model';
@Injectable({
  providedIn: 'root'
})
export class DistrictService {

  constructor(private http: HttpClient) { }

  getDistrict(): Observable<District> {
  return this.http.get<District>(`${environment.url}/district`);
  }
  getDistricts(): Observable<any> {
  return this.http.get<any>(`${environment.url}/district//districts`);
  }
  query(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/district` + (size ? '?page=' + page + '&size=' + size : ''));
  }
  getDistrictBycurrentSearch(search: string, page: number, size: number) {
    return this.http.get<any>(`${environment.url}/district` + ('/_search?search=name:' + search + '&page=' + page + '&size=' + size));
  }
  saveDistrict(District: IDistrict) {
    return this.http.post<any>(`${environment.url}/district`, District);
  }
  getidDistrict(idA: number) {
    return this.http.get(`${environment.url}/district/` + idA);
  }
  updateDistrict(District: IDistrict) {
    return this.http.put<any>(`${environment.url}/district/` + District.id, District);
  }
  deleteDistrict(idA: number) {
    return this.http.delete(`${environment.url}/district/` + idA);
  }
}
